import { ThemeTypes as Types } from "./index";

export const Sidebar = {
  toggleCollapse: () => ({
    type: Types.SIDEBAR.IS_COLLAPSED,
  }),
};
